export default __webpack_public_path__ + "static/media/ep_12.b966ce70.png";